exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/token-list/ipd-token-list/ipd-token-list.component.css
// module id = ../../../../../src/app/token-list/ipd-token-list/ipd-token-list.component.css
// module chunks = main